export const BASE_API_URL = () => {
  return 'https://api.qa.readysetvr.com/api/1';
};
